import { Button } from '@calendly/ui/components/button'
import { AddMiniIcon } from '@calendly/ui/components/icons'

export const AddButton = ({ children, ...props }) => (
  <div>
    <Button
      size="small"
      decoration="secondary-outline"
      responsive={false}
      {...props}
    >
      <AddMiniIcon />
      {children}
    </Button>
  </div>
)
